/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListBusinessMemoriesResponseBody,
  ListBusinessMemoriesResponseBody$inboundSchema,
} from "../components/listbusinessmemoriesresponsebody.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListBusinessMemoriesSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListBusinessMemoriesRequest = {
  /**
   * Cursor for the next result page.
   */
  cursor?: string | undefined;
  /**
   * Exact content-scope tag to match.
   */
  contentScope?: string | undefined;
  /**
   * Content-scope namespace to match.
   */
  contentScopeNamespace?: string | undefined;
  /**
   * Number of memories to return.
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListBusinessMemoriesResponse = {
  result: ListBusinessMemoriesResponseBody;
};

/** @internal */
export type ListBusinessMemoriesSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListBusinessMemoriesSecurity$outboundSchema: z.ZodMiniType<
  ListBusinessMemoriesSecurity$Outbound,
  ListBusinessMemoriesSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listBusinessMemoriesSecurityToJSON(
  listBusinessMemoriesSecurity: ListBusinessMemoriesSecurity,
): string {
  return JSON.stringify(
    ListBusinessMemoriesSecurity$outboundSchema.parse(
      listBusinessMemoriesSecurity,
    ),
  );
}

/** @internal */
export type ListBusinessMemoriesRequest$Outbound = {
  cursor?: string | undefined;
  content_scope?: string | undefined;
  content_scope_namespace?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListBusinessMemoriesRequest$outboundSchema: z.ZodMiniType<
  ListBusinessMemoriesRequest$Outbound,
  ListBusinessMemoriesRequest
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    contentScope: z.optional(z.string()),
    contentScopeNamespace: z.optional(z.string()),
    limit: z._default(z.int(), 50),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      contentScope: "content_scope",
      contentScopeNamespace: "content_scope_namespace",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listBusinessMemoriesRequestToJSON(
  listBusinessMemoriesRequest: ListBusinessMemoriesRequest,
): string {
  return JSON.stringify(
    ListBusinessMemoriesRequest$outboundSchema.parse(
      listBusinessMemoriesRequest,
    ),
  );
}

/** @internal */
export const ListBusinessMemoriesResponse$inboundSchema: z.ZodMiniType<
  ListBusinessMemoriesResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListBusinessMemoriesResponseBody$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listBusinessMemoriesResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListBusinessMemoriesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListBusinessMemoriesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListBusinessMemoriesResponse' from JSON`,
  );
}
